import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { getWarehouseResidueStock as getWarehouseResidueStockApi } from '../../helpers/residue/backend_helper';

export const getWarehouseResidueStock = createAsyncThunk(
	'warehouseResidueStock/getWarehouseResidueStock',
	async (params, { rejectWithValue }) => {
		try {
			const response = await getWarehouseResidueStockApi(params || {});
			return response;
		} catch (error) {
			toast.error('Error al obtener stock RESPEL.', { autoClose: 3000 });
			const message = error?.response?.data?.detail || error?.message;
			return rejectWithValue({ message });
		}
	}
);
